import React from 'react';
import { browserHistory } from 'react-router';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import Card from '../../../core/layout/Card';
import Button from '../../../core/form/Button';
import CheckoutLinkListFilterContainer from './CheckoutLinkListFilterContainer';
import CheckoutLinkListContainer from './CheckoutLinkListContainer';

const CheckoutLinkListScene = () => (
  <div>
    <Breadcrumb
      crumbs={[
        {
          text: 'Checkout links',
        },
      ]}
    />
    <Card
      title="Checkout links"
      actions={
        <Button
          type="primary"
          label="New link"
          icon="plus"
          onClick={() => browserHistory.push('/checkout-links/new')}
        />
      }
    >
      <CheckoutLinkListFilterContainer />
      <CheckoutLinkListContainer />
    </Card>
  </div>
);

export default CheckoutLinkListScene;
